declare namespace $ {

	type $mol_paragraph__title_bog_blitz_lobby_game_leaderboard_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_leaderboard_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['top_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_leaderboard_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_blitz_lobby_game_leaderboard_4 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['bottom_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_leaderboard_5 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['my_row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_leaderboard_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_blitz_lobby_game_leaderboard_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_blitz_lobby_game_leaderboard_row__rank_bog_blitz_lobby_game_leaderboard_8 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['row_rank'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['rank'] >
	>
	type $bog_blitz_lobby_game_leaderboard_row__name_bog_blitz_lobby_game_leaderboard_9 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['row_name'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['name'] >
	>
	type $bog_blitz_lobby_game_leaderboard_row__score_bog_blitz_lobby_game_leaderboard_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['row_score'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['score'] >
	>
	type $bog_blitz_lobby_game_leaderboard_row__mine_bog_blitz_lobby_game_leaderboard_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard['row_mine'] >
		,
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['mine'] >
	>
	export class $bog_blitz_lobby_game_leaderboard extends $mol_view {
		board_content( ): readonly(any)[]
		my_row_content( ): readonly(any)[]
		Top_title( ): $mol_paragraph
		top_rows( ): readonly(any)[]
		Top_list( ): $mol_list
		Bottom_title( ): $mol_paragraph
		bottom_rows( ): readonly(any)[]
		Bottom_list( ): $mol_list
		row_rank( id: any): number
		row_name( id: any): string
		row_score( id: any): number
		row_mine( id: any): boolean
		players_dict( ): any
		my_lord_str( ): string
		is_host( ): boolean
		sub( ): ReturnType< $bog_blitz_lobby_game_leaderboard['board_content'] >
		My_row( ): $mol_view
		Top( ): $mol_view
		Bottom( ): $mol_view
		Row( id: any): $bog_blitz_lobby_game_leaderboard_row
	}
	
}

//# sourceMappingURL=leaderboard.view.tree.d.ts.map